import { Component, EventEmitter, Output } from '@angular/core';
import { productDisplayName } from '@kservice';

@Component({
  selector: 'kp-intro-screen',
  templateUrl: './intro-screen.component.html',
  styleUrls: ['./intro-screen.component.scss'],
})
export class IntroScreenComponent {
  @Output() closeIntro: EventEmitter<boolean> = new EventEmitter();
  productName = productDisplayName;
}
